// src/components/LineChart.js
import React from 'react';

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, ArcElement, ChartDataLabels);

const DonutChart = ({ data, colors }) => {
  let delayed;
  const donutoptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows the canvas to adjust its size
    animation: {
      onComplete: () => {
        delayed = true;
      },
      delay: (context) => {
        let delay = 0;
        if (context.type === 'data' && context.mode === 'default' && !delayed) {
          delay = context.dataIndex * 300 + context.datasetIndex * 100;
        }
        return delay;
      },
    },
    plugins: {
      legend: {
        display: true, // Show or hide the legend
        position: 'bottom', // Position of the legend
        align: 'center', // Alignment of the legend
        labels: {             
          padding: (0, 15, 0, 10), // Padding around the legend labels
          boxWidth: 7, // Width of the color box in the legend
          boxHeight: 7, // Height of the color box in the legend
          usePointStyle: true, // Use point styles instead of boxes             
        },
        title: {
          display: true,
          padding: -7,
        },
      },
  
      datalabels: {
        formatter: (value, ctx) => {
          const total = ctx.chart.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        color: '#fff',
      },
      anchor: 'end',
      align: 'end',
    },
  };
    return (      
        <Doughnut data={data} options={donutoptions} />
    );
  };
  
export default DonutChart;
